"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var ConversionTracking_1 = require("../../functions/ConversionTracking");
function VerifyEmail(_a) {
    var status = _a.status;
    var route = (0, useRoute_1.default)();
    var _b = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }), t = _b.t, i18n = _b.i18n;
    var language = i18n.language;
    var page = (0, useTypedPage_1.default)();
    var form = (0, inertia_react_1.useForm)({});
    var verificationLinkSent = status === "verification-link-sent";
    function onSubmit(e) {
        e.preventDefault();
        form.post(route("verification.send"));
    }
    function trackingRedirect() {
        setTimeout(function () {
            (0, ConversionTracking_1.doTrackingRedirect)(language, "https://nordicscreen.com/signup-successful-emailverify/", "https://nordicscreen.com/signup-successful-en-emailverify/", page);
        }, 1000);
    }
    // Call trackingRedirect on component mount
    (0, react_1.useEffect)(function () {
        trackingRedirect();
    }, []); // Empty dependency array ensures this runs only once
    return (react_1.default.createElement("div", { className: "container-fluid", style: { fontFamily: "Geomanist" } },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-4 col-lg-4 col-xl-4 d-flex flex-column mx-xl-5 px-xl-5" },
                react_1.default.createElement(inertia_react_1.Head, { title: "Email Verification" }),
                react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center mb-4", style: { marginTop: "9rem", color: "var(--info-color)" } },
                    react_1.default.createElement("img", { src: "/images/Q-PlayLogo.svg", className: "mx-auto", style: { width: "132px", height: "26px" } }),
                    react_1.default.createElement("h1", { className: "fw-bold text-center", style: { fontSize: "50px", fontFamily: "Geomanist-bold", marginTop: "1rem", marginBottom: "3rem" } }, t("Verify email")),
                    react_1.default.createElement("p", { style: { color: "black", fontSize: "17px" } }, t("Thanks for signing up! Before getting started, could you verify your email address" +
                        " by clicking on the link we just emailed to you? If you didn't receive" +
                        " the email, we will gladly send you another."))),
                verificationLinkSent && (react_1.default.createElement("div", { className: "mb-4" },
                    react_1.default.createElement("div", { className: "alert", style: { backgroundColor: "var(--warning-color)", color: "#FFFFFF" }, role: "alert" }, t("A new verification link has been sent to the email address you provided during registration.")))),
                react_1.default.createElement("form", { onSubmit: onSubmit },
                    react_1.default.createElement("div", { className: "mt-4 flex items-center justify-between" },
                        react_1.default.createElement(q_play_components_1.Button, { text: t("Resend Verification Email"), className: (0, classnames_1.default)({ "opacity-25": form.processing }, "w-100", "mb-4"), isDisabled: form.processing }),
                        react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("logout"), method: "post", className: "text-black text-center w-100 d-inline-block", "data-cy": "verifyEmailLogoutButton" }, t("Log Out"))))),
            react_1.default.createElement("div", { className: "col d-none d-md-block", style: { backgroundColor: "var(--secondary-color)" } },
                react_1.default.createElement("div", { className: "vh-100 container d-flex align-self-center justify-content-center" },
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("img", { src: "/images/LoginPageGrabDesignShare.svg", className: "rounded mx-auto d-block img-fluid", style: { width: "80vh", height: "80vh" } })))))));
}
exports.default = VerifyEmail;
